var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8465 58.9046H56.2539V54.2167H39.8465V28.4336H72.8176V23.2643L37.5026 0L2.1875 23.2643V28.4336H35.1586V54.2167H18.7512V58.9046H35.1586V75.312H28.1269V79.9998H46.8782V75.312H39.8465V58.9046ZM27.5932 23.7458L37.5026 7.34037L47.4119 23.7458H27.5932ZM52.8887 23.7458L44.8665 10.4647L65.0269 23.7458H52.8887ZM30.1386 10.4647L22.1164 23.7458H9.97806L30.1386 10.4647Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6617 44.8411C68.7844 44.8411 65.6299 47.9955 65.6299 51.8728V63.5924H51.5664V79.9999H56.2542V68.2803H65.6299V79.9999H70.3178V51.8728C70.3178 50.5804 71.3692 49.5289 72.6617 49.5289H75.0056V44.8411H72.6617Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37568 51.8728C9.37568 47.9955 6.22123 44.8411 2.34392 44.8411H0V49.5289H2.34392C3.63636 49.5289 4.68784 50.5804 4.68784 51.8728V79.9999H9.37568V68.2803H18.7514V79.9999H23.4392V63.5924H9.37568V51.8728Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility11);
export default __webpack_public_path__ + "static/media/gefion-facility-11.133d9c5f92f6d89bd7c9725095185d87.svg";
export { ForwardRef as ReactComponent };